import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { Skeleton } from '@/common/ui/skeleton'
import useQueryGetDepositPromotion from '@/modules/promotion/api/hooks/useQueryGetDepositPromotion'

interface PromotionSelectorProps {
	value?: string
	onChange: (value: string) => void
	disabled?: boolean
	filterInstantClaimOnly?: boolean
}

export const PromotionSelector = ({
	value,
	onChange,
	disabled = false,
	filterInstantClaimOnly = false,
}: PromotionSelectorProps) => {
	const { data, isLoading } = useQueryGetDepositPromotion({
		take: 100,
		skip: 0,
	})

	if (isLoading) {
		return <Skeleton className="h-10 w-full" />
	}

	// Filter promotions based on active status and instant claim eligibility
	const promotions = (data?.data || []).filter((promotion) => {
		if (!promotion.isActive) return false
		if (filterInstantClaimOnly && !promotion.allowInstantClaim) return false
		return true
	})

	return (
		<Select value={value} onValueChange={onChange} disabled={disabled}>
			<SelectTrigger>
				<SelectValue placeholder="เลือกโปรโมชั่น" />
			</SelectTrigger>
			<SelectContent>
				{promotions.length === 0 ? (
					<div className="p-2 text-center text-sm text-muted-foreground">
						ไม่มีโปรโมชั่นที่เปิดใช้งาน
					</div>
				) : (
					promotions.map((promotion) => (
						<SelectItem key={promotion.id} value={promotion.id}>
							<div className="flex flex-col">
								<span className="font-medium">{promotion.name}</span>
								{promotion.description && (
									<span className="text-xs text-muted-foreground">
										{promotion.description.length > 50
											? `${promotion.description.substring(0, 50)}...`
											: promotion.description}
									</span>
								)}
							</div>
						</SelectItem>
					))
				)}
			</SelectContent>
		</Select>
	)
}
